<template>
    <div class="wrapper-box">
        <web-header></web-header>
        <web-slide :data="data"></web-slide>
        <section class="section wow fadeIn">
            <div class="container">
                <div class="columns">
                    <div class="column is-2">

                    </div>
                    <div class="column is-9 has-text-centered">
                        <strong>
                        El Absorbente sanitario de marlo es producido por Nelsoni Ranch con mazorcas de maíz bajo métodos especiales de cosecha que aseguran una calidad de materias primas de primer nivel y un porcentaje de humedad por debajo del 10% lo que hace posible aprovechar su excepcional capacidad de absorción.
                        Luego del proceso de triturado este producto se lo clasifica para obtener un producto libre de polvo, el cual brinda un ALTO PODER DE ABSORCION, RETIENE LOS OLORES y resulta muy RENDIDOR economizando su compra.

                        </strong>
                       
                    </div>
                    
                    <div class="column is-2">

                    </div>
                </div>

            </div>
        </section>
        <web-products :products="products"></web-products>
        <web-parallax></web-parallax>
        <web-footer></web-footer>
        <web-arrow-up></web-arrow-up>
    </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import products from "@/components/categories/products";
import arrowUp from "@/components/arrowUp.vue";
import bg from "../../assets/images/categories/banners/titulo_bedding.jpg";
import bgMob from "../../assets/images/categories/banners/titulo_bedding_mobile.jpg";

import img1 from "../../assets/images/products/bedding_virutademarlo.jpg";
import img2 from "../../assets/images/products/bedding_marloparagatos.jpg";
import img3 from "../../assets/images/products/bedding_marlopararoedores.jpg";

export default {
  name: "BeddingAndLibtterCamas",
  data() {
    return {
      data: [
        {
          html:
            " <h1>BEDDING &amp; LITTER <br> CAMAS</h1><p>Elaborado en su totalidad por marlo de maíz molido el cuál brinda un ALTO PODER DE ABSORCIÓN RETIENE los OLORES y resulta muy RENDIDOR economizando su compra. </p>",
          style:
            "background:url(" +
            this.getBg() +
            ") no-repeat; background-size:cover;    background-position: center; height:300px; "
        }
      ],
      products: [
        {
          image: img3,
          title:
            "MARLO PARA ROEDORES Y AVES / CORN COB BED / ABSORBENTE SANITARIO ",
          description:
            "Se recomienda el uso en camas de pequeñas mascotas como  hámster, cobayo, conejos, ferrets (hurones) y erizos. Otra excelente aplicación se encuentra en jaulas de aves usando el marlo como base en la bandeja de la jaula favoreciendo el control de olores y absorbiendo excesos de humedad. No se recomienda el uso en iguanas.",
          extraData: "Presentación 1,2 Kg. /4 Kg./14 Kg."
        },
        {
          image: img1,
          title: "VIRUTA DE MARLO",
          description:
            "Excelente cama para mascotas tales conejos, cobayos, hamsters, chinchillas, erizos y otros animales que requieran de un entorno saludable. SUPER ABSORBENTE y libre de polvo. Facilita el armado de nidos. La Viruta de Marlo es 100% biodegradable, producto apto para compostar.",
          extraData: "Presentación: 500 gr. / 2,5 kg. / 10 kg."
        },
        {
          image: img2,
          title: "MARLO PARA GATOS / CORN COB BED / ABSORBENTE SANITARIO",
          description: `Se recomienda el uso en las literas de los gatos, favoreciendo el control de olores y                   absorbiendo excesos de humedad.
                    <p>
                    -	No tóxico </br>
                    -	Excelente control de olores </br>
                    -	Fácil de limpiar: no se pega en la litera y el producto es muy liviano </br>
                    -	Absorbe 4 veces más que las camas convencionales
                    </p>
                    <p>
                    El marlo es un absorbente sanitario de origen natural, vegetal, constituido únicamente con mazorcas de maíz.
                    </p>
                    <p>
                    Nuestro producto se tamiza para asegurar una superficie confortable para su mascota. No contiene arcilla, ni colorantes, ni perfume. Libre de polvo para brindarle un entorno más saludable para 
                    su gato.
                    </p>
                    <p>
                    El marlo funciona mediante la absorción de la orina del gato y se caracteriza por su alto nivel de evaporación reteniendo en este proceso los intensos olores.
                    También puede utilizarse en otros animales pequeños como aves, hurones, conejos y otros roedores.
                    </p>
                    <p>
                    Instrucciones de Uso:
                    </p>
                    <p>
                    Debe llenar la litera con 2 ó 3 cm de producto, cantidad que le permite a usted una fácil limpieza y a su gato le brinda el suficiente material para enterrar sus residuos.
                    Es recomendable quitar los residuos sólidos diariamente y cuando el producto pierda su capacidad de absorción debe vaciar la litera, lavarla y reemplazar por material fresco.
                    Nota: mientras que algunos gatos pueden cambiar de un tipo de absorbente a otro con facilidad, su gato puede requerir una transición.  Si es así, usted debe seguir estos simples pasos:
                    </p>
                    <p>
                    Semana  1: mezcle 1/3 de marlo con su absorbente actual</br>
                    Semana 2: mezcle ½ de marlo y ½ de su absorbente actual</br>
                    Semana 3: utilice 100% la cama de marlo.
                    </p>`,
          extraData: "Presentación 1,2 Kg. /4 Kg. /14 Kg."
        }
      ]
    };
  },
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webProducts: products,
    webArrowUp: arrowUp
  },
  methods: {
    detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg() {
      if (this.detectmob()) {
        return bgMob;
      }
      return bg;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/categories/beddingAndLitterCamas.vue